import { FeatureCollection } from 'geojson';

// GeoJSON oficial do Rio Grande do Sul
// Fonte: IBGE - Instituto Brasileiro de Geografia e Estatística
// API: https://servicodados.ibge.gov.br/api/v3/malhas/estados/43
export const RS_GEOJSON: FeatureCollection = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: {
        name: "Rio Grande do Sul",
        sigla: "RS",
        codarea: "43",
        type: "state"
      },
      geometry: {
        type: "Polygon",
        coordinates: [[
          // Coordenadas oficiais do IBGE
          [-53.9475, -31.9546], [-53.7256, -32.0984], [-53.6765, -32.2381], [-53.644, -32.3849],
          [-53.4369, -32.5482], [-53.1764, -32.6585], [-52.9974, -32.5912], [-52.968, -32.4905],
          [-52.8024, -32.447], [-52.7242, -32.37], [-52.8211, -32.3341], [-52.7189, -32.1542],
          [-52.6229, -32.1456], [-52.6884, -32.3195], [-52.6023, -32.4606], [-52.6209, -32.6379],
          [-52.7234, -32.8339], [-52.8322, -32.915], [-53.0016, -32.7975], [-53.1239, -32.7938],
          [-53.1744, -33.0035], [-53.2602, -33.1074], [-53.3253, -33.0652], [-53.4692, -33.2554],
          [-53.4248, -33.4376], [-53.5078, -33.5311], [-53.5228, -33.6893], [-53.422, -33.7438],
          [-53.37, -33.7439], [-52.7767, -33.2831], [-52.6239, -33.1042], [-52.4952, -32.8672],
          [-52.4229, -32.6288], [-52.293, -32.3383], [-52.0972, -32.1617], [-52.1148, -31.942],
          [-52.2566, -31.8498], [-52.2236, -31.7889], [-52.1524, -31.6993], [-52.036, -31.6958],
          [-52.0135, -31.5972], [-52.0102, -31.5009], [-51.9195, -31.3108], [-51.8117, -31.2857],
          [-51.6191, -31.269], [-51.6287, -31.153], [-51.5378, -31.115], [-51.442, -31.0874],
          [-51.4993, -30.9758], [-51.4488, -30.8722], [-51.3727, -30.8725], [-51.3809, -30.6435],
          [-51.3188, -30.6461], [-51.2654, -30.4798], [-51.1358, -30.4368], [-51.2101, -30.3013],
          [-51.3283, -30.2265], [-51.3012, -30.0542], [-51.2719, -30.039], [-51.2327, -30.1827],
          [-51.0629, -30.2596], [-51.0556, -30.392], [-50.93, -30.4358], [-50.9148, -30.3264],
          [-50.6561, -30.286], [-50.6208, -30.1984], [-50.5426, -30.2523], [-50.5827, -30.4901],
          [-50.7295, -30.3681], [-50.6864, -30.5008], [-50.6901, -30.7069], [-50.7538, -30.8189],
          [-50.9668, -30.8961], [-50.9546, -31.0032], [-51.179, -31.1342], [-51.1575, -31.2847],
          [-51.2375, -31.4574], [-51.3611, -31.532], [-51.4282, -31.492], [-51.6587, -31.7669],
          [-51.8377, -31.801], [-51.9028, -31.8705], [-52.0981, -31.8359], [-52.0152, -31.9224],
          [-52.0772, -32.1432], [-51.8309, -31.9192], [-51.4272, -31.6956], [-51.186, -31.5044],
          [-50.8421, -31.19], [-50.7672, -31.1101], [-50.3343, -30.5008], [-50.2519, -30.3049],
          [-50.2241, -30.2363], [-50.1703, -30.0971], [-50.1192, -29.9762], [-50.0753, -29.8845],
          [-50.0637, -29.86], [-50.0176, -29.7725], [-49.9337, -29.6251], [-49.9222, -29.6072],
          [-49.8035, -29.4436], [-49.7129, -29.3256], [-49.7918, -29.2856], [-49.9016, -29.2153],
          [-49.9576, -29.1995], [-50.1143, -29.2576], [-50.034, -29.3496], [-50.041, -29.3551],
          [-50.1446, -29.2702], [-50.1378, -29.1937], [-50.0163, -29.1828], [-49.9576, -29.0682],
          [-49.9557, -28.9489], [-49.9509, -28.8935], [-49.9347, -28.7257], [-49.8402, -28.7131],
          [-49.7826, -28.6098], [-49.7041, -28.63], [-49.7031, -28.6289], [-49.7269, -28.5189],
          [-49.8163, -28.469], [-49.9708, -28.4402], [-50.0687, -28.4792], [-50.4248, -28.4333],
          [-50.6139, -28.3936], [-50.6956, -28.2699], [-50.7491, -28.2485], [-50.8753, -28.0413],
          [-50.9784, -27.9482], [-51.0015, -27.9632], [-51.0567, -27.8868], [-51.0534, -27.8689],
          [-51.2733, -27.7355], [-51.3088, -27.7195], [-51.4573, -27.6075], [-51.5476, -27.5591],
          [-51.5784, -27.577], [-51.6326, -27.4886], [-51.7012, -27.4798], [-51.788, -27.5148],
          [-51.8371, -27.5222], [-51.8582, -27.4751], [-51.9834, -27.3751], [-52.049, -27.3463],
          [-52.1071, -27.3434], [-52.2248, -27.3306], [-52.2613, -27.2569], [-52.2998, -27.3191],
          [-52.3978, -27.2925], [-52.4192, -27.2824], [-52.4325, -27.2178], [-52.5363, -27.2601],
          [-52.5446, -27.2406], [-52.6915, -27.2844], [-52.7855, -27.206], [-52.801, -27.2034],
          [-52.8513, -27.1703], [-52.9712, -27.2178], [-52.9925, -27.14], [-53.0178, -27.0931],
          [-53.0767, -27.1078], [-53.1877, -27.1923], [-53.3225, -27.2099], [-53.2962, -27.1324],
          [-53.3554, -27.1113], [-53.4882, -27.1938], [-53.5478, -27.1764], [-53.5997, -27.1894],
          [-53.7177, -27.1825], [-53.8197, -27.1757], [-53.8371, -27.1684], [-53.9466, -27.1513],
          [-54.055, -27.264], [-54.1115, -27.3025], [-54.1866, -27.2649], [-54.2174, -27.385],
          [-54.2839, -27.4478], [-54.4114, -27.4053], [-54.4746, -27.4812], [-54.5894, -27.4582],
          [-54.632, -27.5457], [-54.7233, -27.5635], [-54.8171, -27.5356], [-54.9029, -27.6989],
          [-54.9993, -27.7905], [-55.0517, -27.8524], [-55.2027, -27.8579], [-55.2778, -27.9329],
          [-55.3398, -27.966], [-55.3755, -28.034], [-55.4384, -28.0863], [-55.7712, -28.2415],
          [-55.6692, -28.3408], [-55.6922, -28.4164], [-55.8506, -28.3554], [-55.884, -28.4792],
          [-56.0232, -28.5228], [-56.0024, -28.5783], [-56.1942, -28.7752], [-56.2997, -28.8081],
          [-56.3233, -28.9247], [-56.4304, -29.0795], [-56.5888, -29.1198], [-56.6645, -29.295],
          [-56.78, -29.42], [-56.9711, -29.6434], [-57.1319, -29.7702], [-57.2354, -29.7808],
          [-57.3297, -29.8876], [-57.3281, -29.9719], [-57.4646, -30.1103], [-57.5941, -30.179],
          [-57.568, -30.2522], [-57.3894, -30.3025], [-57.2042, -30.2851], [-57.1152, -30.1137],
          [-56.8504, -30.0889], [-56.6581, -30.2013], [-56.5461, -30.3606], [-56.4622, -30.3845],
          [-56.3781, -30.5015], [-56.2899, -30.5323], [-56.1877, -30.6047], [-56.1501, -30.7055],
          [-56.0236, -30.7857], [-56.0111, -31.0816], [-55.8708, -31.0716], [-55.6662, -30.954],
          [-55.5786, -30.8329], [-55.437, -31.0047], [-55.3514, -31.0376], [-55.2468, -31.2522],
          [-55.0745, -31.3321], [-55.0358, -31.2839], [-54.8365, -31.4419], [-54.7013, -31.4357],
          [-54.5869, -31.4565], [-54.4729, -31.5704], [-54.4546, -31.6528], [-54.088, -31.9312],
          [-53.9475, -31.9546] // Fecha o polígono
        ]]
      }
    }
  ]
};

// Cidades principais do RS com coordenadas precisas
export const RS_CITIES_GEOJSON: FeatureCollection = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: { name: "Porto Alegre", population: 1488000, type: "city" },
      geometry: { type: "Point", coordinates: [-51.2177, -30.0346] }
    },
    {
      type: "Feature",
      properties: { name: "Caxias do Sul", population: 517451, type: "city" },
      geometry: { type: "Point", coordinates: [-51.1794, -29.1634] }
    },
    {
      type: "Feature",
      properties: { name: "Pelotas", population: 343132, type: "city" },
      geometry: { type: "Point", coordinates: [-52.3451, -31.7654] }
    },
    {
      type: "Feature",
      properties: { name: "Canoas", population: 348208, type: "city" },
      geometry: { type: "Point", coordinates: [-51.1740, -29.9178] }
    },
    {
      type: "Feature",
      properties: { name: "Santa Maria", population: 283677, type: "city" },
      geometry: { type: "Point", coordinates: [-53.8069, -29.6868] }
    },
    {
      type: "Feature",
      properties: { name: "Gravataí", population: 281519, type: "city" },
      geometry: { type: "Point", coordinates: [-50.9919, -29.9439] }
    },
    {
      type: "Feature",
      properties: { name: "Viamão", population: 256302, type: "city" },
      geometry: { type: "Point", coordinates: [-51.0233, -30.0811] }
    },
    {
      type: "Feature",
      properties: { name: "Novo Hamburgo", population: 247032, type: "city" },
      geometry: { type: "Point", coordinates: [-51.1306, -29.6783] }
    },
    {
      type: "Feature",
      properties: { name: "São Leopoldo", population: 238648, type: "city" },
      geometry: { type: "Point", coordinates: [-51.1469, -29.7603] }
    },
    {
      type: "Feature",
      properties: { name: "Rio Grande", population: 211965, type: "city" },
      geometry: { type: "Point", coordinates: [-52.0986, -32.0350] }
    },
    {
      type: "Feature",
      properties: { name: "Passo Fundo", population: 204722, type: "city" },
      geometry: { type: "Point", coordinates: [-52.4066, -28.2576] }
    },
    {
      type: "Feature",
      properties: { name: "Uruguaiana", population: 130000, type: "city" },
      geometry: { type: "Point", coordinates: [-57.0853, -29.7614] }
    },
    {
      type: "Feature",
      properties: { name: "Bagé", population: 120000, type: "city" },
      geometry: { type: "Point", coordinates: [-54.1069, -31.3289] }
    },
    {
      type: "Feature",
      properties: { name: "Santa Cruz do Sul", population: 130000, type: "city" },
      geometry: { type: "Point", coordinates: [-52.4256, -29.7175] }
    },
    {
      type: "Feature",
      properties: { name: "Erechim", population: 106000, type: "city" },
      geometry: { type: "Point", coordinates: [-52.2739, -27.6342] }
    }
  ]
};
